import gql from "fraql";

export const GET_PERSON_DOCUMENTS = gql`
  query GetPersonDocuments($personId: String!, $offset: Int!, $limit: Int!) {
    Document(
      limit: $limit
      offset: $offset
      where: { personId: { _eq: $personId } }
      order_by: [{ sightedDate: desc_nulls_last }, { expiryDate: asc_nulls_last }]
    ) {
      id
      docType
      documentNumber
      expiryDate
      sightedDate
      sightedBy
      personId
      comments
      SightedBy {
        id
        email
      }
    }
    Document_aggregate(where: { personId: { _eq: $personId } }) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_DOCUMENT_BY_ID = gql`
  query GetDocumentById($id: String!) {
    Document_by_pk(id: $id) {
      id
      docType
      documentNumber
      expiryDate
      sightedDate
      sightedBy
      personId
      comments
      Person {
        id
        firstName
        lastName
      }
      SightedBy {
        id
        email
      }
    }
  }
`;

export const CREATE_DOCUMENT = gql`
  mutation CreateDocument(
    $docType: String!
    $documentNumber: String!
    $personId: String!
    $comments: String!
    $expiryDate: date
    $sightedDate: timestamptz
    $sightedBy: String
  ) {
    insert_Document_one(
      object: {
        docType: $docType
        documentNumber: $documentNumber
        personId: $personId
        comments: $comments
        expiryDate: $expiryDate
        sightedDate: $sightedDate
        sightedBy: $sightedBy
      }
    ) {
      id
      docType
      documentNumber
      expiryDate
      personId
      comments
    }
  }
`;

export const UPDATE_DOCUMENT = gql`
  mutation UpdateDocument(
    $id: String!
    $docType: String
    $documentNumber: String
    $expiryDate: date
    $comments: String
  ) {
    update_Document_by_pk(
      pk_columns: { id: $id }
      _set: {
        docType: $docType
        documentNumber: $documentNumber
        expiryDate: $expiryDate
        comments: $comments
      }
    ) {
      id
      docType
      documentNumber
      expiryDate
      sightedDate
      sightedBy
      comments
    }
  }
`;

export const DELETE_DOCUMENT = gql`
  mutation DeleteDocument($id: String!) {
    delete_Document_by_pk(id: $id) {
      id
      docType
      documentNumber
    }
  }
`;

export const GET_PERSON_DOCUMENT_TYPES = gql`
  query GetPersonDocumentTypes($personId: String!, $limit: Int!, $offset: Int!) {
    Document(
      limit: $limit
      offset: $offset
      where: { personId: { _eq: $personId } }
    ) {
      id
      docType
    }
  }
`;
